export type AuthVersion = "v0" | "v1";

export enum AuthVersionEnum {
  V0 = "v0",
  V1 = "v1",
}

export interface UserResponse {
  id: string;
  refId?: string;
  displayName: string;
  segment?: string[];
}

export interface AuthResponse {
  data?: {
    error?: { code: string; message: string };
    user: UserResponse;
    token: string;
  };
}

export interface AuthContextProps {
  isLoggedIn: boolean;
  getCurrentUser: UserResponse | null;
  token: string | null;
  isLoading?: boolean;
  isForbidden?: boolean;
}

export interface AuthParams {
  session?: string;
  apiKey?: string;
  hash?: string;
  ts?: number;
  [key: string]: any;
}

export interface AuthConfig {
  version: AuthVersion;
  endpoint: string;
  requiredParams: string[];
  payload?: Record<string, any>;
}

export interface AuthResponseData {
  getCurrentUser?: UserResponse;
  user: UserResponse;
  token: string;
  error?: { code: string; message: string };
}
